import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { selectAnatomy } from '@chakra-ui/anatomy';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(selectAnatomy.keys);

const variants = {
  outline: {
    field: {
      bgColor: 'chakra-body-bg',
      borderRadius: 'lg',
      borderWidth: '2px',
    },
  },
};

export const selectTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle: {
    field: {
      borderRadius: 'lg',
    },
  },
  variants,
});
